import React, {Fragment, useEffect, useState } from "react";
import QRCode from 'qrcode.react';
import api from '../adapters/api';
import {
    MDBTable,
    MDBTableHead,
    MDBTableBody
  } from 'mdb-react-ui-kit';
const generatePayload = require('promptpay-qr');


const CustomerPOS = () => {
  const [data , setData] = useState("");
  const taxId = '0505554005352'
  const amount = parseFloat(600.00)
  const qrCodeValue = generatePayload(taxId, { amount });

  useEffect(() => {    
    const fetchLastUpdate = async () => {
      const response = await api.post(`/api/customerpos`);
      setData(response.data[0])          
  } 
  fetchLastUpdate(); 
  },[]);    

  return(
      // <section class="w-100 p-4 d-flex justify-content-center pb-4">
      //   <div class="col-md-5" >                        
      //       last updated by : {data.discount} {data.qty}  = {data.sum_amount}                   
      //   </div>
      // </section>
    <div>
      <div style={{ marginTop: '20px' }}>
        {qrCodeValue && <QRCode value={qrCodeValue} size={256} />}
      </div>
    </div>

    
  );

}

export default CustomerPOS;